import React, { FunctionComponent } from 'react';
import { PalletDetail } from '../../../types/palletDetail';
import _ from 'lodash';

interface PalletsDisplayProps {
  pallets: PalletDetail[]; // Ideally, this would be typed to whatever structure your pallets are
  siteId: number;
}

const ModalDefects2PalletsDisplay: FunctionComponent<PalletsDisplayProps> = ({ pallets, siteId }) => {
  // This function will extract unique SSCCs from the pallets and join them as a string
  const displaySSCCs = (pallets: any[]): string => {
    if (!Array.isArray(pallets)) return '';
    
    const uniqueSSCCs = _.uniq(pallets.map(x => siteId === 7 ? x.lot + '-' + x.sequenceNo : x.sscc)).sort();
    return uniqueSSCCs.join(', ');
  };

  return (
    <div className="form-row modal-pallets">
      {displaySSCCs(pallets)}
    </div>
  );
};

export default ModalDefects2PalletsDisplay;